export const TransferStyle = {
	fullWidth: `.ant-transfer {
        width: 100%
    }`
};


// WEBPACK FOOTER //
// ./src/theme/AntdStyle.js